import { observer } from 'mobx-react';


const RiseCredentials: React.FC = observer(() => {
    return (
        <>
        </>
    )
});

export default RiseCredentials;
